import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { SCROLL_RESET } from 'Reducers/scrollPage/types';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const scrollTop = () => {
    store.dispatch({ type: SCROLL_RESET });
    mediator.publish('ui:main-wrapper:scroll-top');
};
// Render the passed in step and optionally warp it with a bootstrap card
const wizardStepWrapperProvider = (Step, props) => {
    const WizardStepWrapper = ({ withoutWrapper, ...props }) => {
        const stepRef = useRef(null);
        if (withoutWrapper) {
            return (React.createElement("div", { ref: stepRef },
                React.createElement(Step, { ...props })));
        }
        else {
            return (React.createElement("div", { className: "row", ref: stepRef },
                React.createElement("div", { id: "wizard-card", className: "w-100" },
                    React.createElement(Step, { ...props }))));
        }
    };
    return React.createElement(WizardStepWrapper, { ...props });
};
const Wizard = ({ initialValues, currentStep, steps, ...props }) => {
    const [currentState, setCurrentState] = useState({
        currentStep: currentStep ?? 0,
        values: initialValues,
    });
    useEffect(() => {
        setCurrentState((currState) => {
            const newState = { ...currState };
            if (initialValues) {
                newState.values = initialValues;
            }
            if (currentStep) {
                newState.currentStep = currentStep;
            }
            return newState;
        });
    }, [initialValues, currentStep]);
    const back = useCallback((values) => {
        if (currentState.currentStep === 0) {
            mediator.publish('router:back');
        }
        else {
            scrollTop();
            setCurrentState((currState) => {
                const newState = { ...currState };
                if (currState.currentStep > 0) {
                    newState.currentStep -= 1;
                }
                if (values) {
                    newState.values = values;
                }
                return newState;
            });
        }
    }, [currentState.currentStep]);
    const next = useCallback((values) => {
        scrollTop();
        setCurrentState((currState) => {
            const newState = { ...currState };
            if (values) {
                newState.values = values;
            }
            // check the call is from the current step, to prevent it from being called
            // by the same step more than once
            if (steps[currState.currentStep] && currState.currentStep < steps.length - 1) {
                newState.currentStep += 1;
            }
            return newState;
        });
    }, [steps]);
    // Setup navigation blocking while we are inside the wizard
    useEffect(() => {
        let canceled = false;
        const { currentStep } = currentState;
        const _setUpBlockNavigation = () => {
            mediator.publish('router:blockNavigation', (_, isBack) => {
                if (canceled) {
                    return false;
                }
                if (isBack && currentStep === 0) {
                    return false;
                }
                else if (isBack) {
                    back();
                }
                else {
                    return false;
                }
                return true;
            });
        };
        _setUpBlockNavigation();
        return () => {
            canceled = true;
        };
    }, [back, currentState]);
    const step = wizardStepWrapperProvider(steps[currentState.currentStep]?.component, {
        ...steps[currentState.currentStep]?.props,
        ...props,
        back,
        key: currentState.currentStep,
        lastStep: currentState.currentStep === steps.length - 1,
        next,
        values: currentState.values,
        currentStep: currentState.currentStep,
    });
    return React.createElement(React.Fragment, null, step);
};
export default memo(Wizard);
